import {Component} from '@angular/core';
import {LoaderService} from './loader.service';

/**
 * Implementação do component responsável por gerar a tela de loading, lockscreen
 */
@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html'
})
export class LoaderComponent {

    display = false;

    constructor(private loaderService: LoaderService) {
        this.loaderService.onChangeDisplay.subscribe(newValue => {
            this.display = newValue;
        });
    }

}
